export { default as extractEventHandlers } from '@mui/utils/extractEventHandlers';